"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bifrost_number_1 = __importDefault(require("@bifrost-platform/bifrost-number"));
const MethodConfig_1 = __importDefault(require("../../interface/MethodConfig"));
const config_1 = __importDefault(require("../../config"));
class Srd {
    constructor() {
        this.requireLevel = config_1.default.REQUIRE_LEVEL.PARTIALLY;
        this.id = '';
        this.entryPointID = '';
        this.defaultDecimals = new bifrost_number_1.default('10').pow(config_1.default.default.decimals);
    }
    getMethodProps() {
        return [
            new MethodConfig_1.default('srd.market', [{
                    id: 'blockNumber.from',
                    valueID: 'blockNumber'
                }, {
                    id: 'blockNumber.to',
                    valueID: 'blockNumber.yearLater'
                }], ''),
            new MethodConfig_1.default('srd.market', [{
                    id: 'blockNumber.from',
                    valueID: 'blockNumber'
                }, {
                    id: 'blockNumber.to',
                    valueID: 'blockNumber.weekLater'
                }], ''),
            new MethodConfig_1.default('srd.user', [{
                    id: 'blockNumber.from',
                    valueID: 'blockNumber'
                }, {
                    id: 'blockNumber.to',
                    valueID: 'blockNumber.yearLater'
                }], '')
        ];
    }
    proccessCallResponse(responses, isValidAddress, network, currency, args, cacheArgs) {
        const blocksPerWeek = cacheArgs['blockNumber.weekLater'] - cacheArgs['blockNumber'];
        const blocksPerYear = cacheArgs['blockNumber.yearLater'] - cacheArgs['blockNumber'];
        const rawMarketYear = (responses[0] || [])[0] || [];
        const rawMarketWeek = (responses[1] || [])[0] || [];
        const rawUserYear = (responses[2] || [])[0] || [];
        const market = {
            rewardStartBlockNumber: parseInt(rawMarketWeek[0]) || 0,
            distributedAmount: new bifrost_number_1.default(rawMarketWeek[1] || '0').div(this.defaultDecimals).toStr(),
            totalDeposit: new bifrost_number_1.default(rawMarketWeek[2] || '0').div(this.defaultDecimals).toStr(),
            weekPoolRate: new bifrost_number_1.default(rawMarketWeek[3] || '0').div(this.defaultDecimals).mul(blocksPerWeek).toStr(),
            yearPoolRate: new bifrost_number_1.default(rawMarketYear[3] || '0').div(this.defaultDecimals).mul(blocksPerYear).toStr()
        };
        const user = {
            stakedTokenAmount: '0',
            rewardStartBlockNumber: parseInt(rawUserYear[1]) || 0,
            claimStartBlockNumber: parseInt(rawUserYear[2]) || 0,
            earnedTokenAmount: '0',
            weekPoolRate: '0',
        };
        if (isValidAddress) {
            user.stakedTokenAmount = new bifrost_number_1.default(rawUserYear[0] || '0').div(this.defaultDecimals).toStr();
            user.earnedTokenAmount = new bifrost_number_1.default(rawUserYear[3] || '0').div(this.defaultDecimals).toStr();
            user.weekPoolRate = new bifrost_number_1.default(rawUserYear[4] || '0').div(this.defaultDecimals).mul(blocksPerWeek).toStr();
        }
        return {
            market,
            user
        };
    }
}
exports.default = Srd;
;
//# sourceMappingURL=Srd.js.map